<lottie-player #player data-testid="lottie-player"></lottie-player>
